import {
  AllowedCurrencyType,
  LinksListType,
  NotificationSettingsWidgetLevel,
  WidgetNames,
  WidgetTitles,
} from '@finxone-platform/shared/sys-config-types';
import { BaseWidgetBuilder, IWidgetBuilder, initWidgetBuilder } from './base-builder';
import { getEditBeneficiaryAddressWidget } from './beneficiary-zone/beneficiary-widgets';
import {
  getIntlCurrencyCountryWidgetConfigEditBeneficairy,
  getIntlNewCurrencyCountryWidgetConfigEditBeneficiary,
} from './beneficiary-zone/edit-beneficiary.type';
import {
  addToAppleWalletWidgetConfig,
  addToGooglePayWidgetConfig,
  currencyInputFieldWidgetConfig,
  getCTAButtonsWidgetConfig,
  iFrameWidgetWidgetConfig,
  imageWidgetWidgetConfig,
  lineWidgetWidgetConfig,
  paymentRefConfig,
  textWidgetWidgetConfig,
} from './display-widgets.type';
import { cardNameWidgetConfig } from './forms/card-name-widget-config';
import {
  accordionWidgetConfig,
  sectionWidgetConfig,
  spacerWidgetConfig,
  tabWidgetConfig,
  twoColumnWidgetConfig,
} from './layout-widget-constants';
import { generateOnboardingWidgetsWorkflowWidgetConfig } from './onboarding/onboarding.type';
import {
  addCurrencyAccountWidgetConfig,
  bulkPaymentAccountsListingWidgetConfig,
  exchangeCurrencyWidgetConfig,
  intlCurrencyCountryWidgetConfig,
} from './payments/payments.type';
import {
  biometricsAuthenticationWidgetConfig,
  calendarWidgetConfig,
  profilePictureWidgetConfig,
} from './profile/profile.type';
import { accountRequestListWidgetConfig } from './savings-accounts-widgets';
import {
  accountsContextDropdownWidgetConfig,
  backButtonWidgetConfig,
  backNextButtonWidgetConfig,
  beneficiaryTypeWidgetConfig,
  cardPinWidgetConfig,
  cardSensitiveDetailsConfig,
  cardsWidgetConfig,
  conditionalWidgetConfig,
  currencyAccountsListingWidgetConfig,
  desktopBulkPaymentHistoryListingWidgetConfig,
  desktopBulkPaymentListingWidgetConfig,
  desktopPaymentRequestPendingListingWidgetConfig,
  editAddressWidget,
  exchangetransactionHistoryWidgetConfig,
  fileUploadWidgetConfig,
  lottieAnimationWidgetConfig,
  multiIconQuickLinkWidgetConfig,
  notificationWidgetConfig,
  paymentRailSelectorWidgetConfig,
  quickLinkWidgetConfig,
  resendLinkWidgetConfig,
  secondaryIdentifierWidgetConfig,
  switchNavigatorQuickLinkWidgetConfig,
  uploadFileWithPopupWidgetConfig,
  verificationOrganisationCompanyNameWidget,
} from './workflow-ui-constants.v2.type';
import { getThemeSelectorWidgetConfig } from './workflow-widget-configurations';

export class LineWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(lineWidgetWidgetConfig);
  }
}

export class NameWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.NAME_WIDGET));
  }
}

export class BirthdayWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(
      generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.BIRTHDAY_WIDGET),
    );
  }
}

export class PhoneWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.PHONE_WIDGET));
  }
}

export class EmailWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.EMAIL_WIDGET));
  }
}

export class AddressWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(
      generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.ADDRESS_WIDGET),
    );
  }
}

export class PasswordWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(
      generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.PASSWORD_WIDGET),
    );
  }
}

export class TextWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(textWidgetWidgetConfig);
  }

  updateWidgetName(widgetName: WidgetNames): this {
    this.widget.name = widgetName;
    return this;
  }

  setTextStylingClass(className: string): this {
    this.widget.widgetConfiguration.attributes.widgetProperties.textStyleClass = className;
    return this;
  }

  isTextEditable(isTextEditable: boolean): IWidgetBuilder {
    this.widget.widgetConfiguration.attributes.widgetProperties['isTextEditable'] = isTextEditable;
    return this;
  }
}

export class ProfilePictureWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(profilePictureWidgetConfig);
  }
}
export class QuickLinkWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(quickLinkWidgetConfig);
  }

  icon(text: string): this {
    this.widget.widgetConfiguration.attributes.widgetProperties.icon = text;
    return this;
  }

  zone(zone: string): this {
    this.widget.widgetConfiguration.attributes['zone'] = zone;
    return this;
  }
}
export class ResendLinkWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(resendLinkWidgetConfig);
  }

  icon(text: string): this {
    this.widget.widgetConfiguration.attributes.widgetProperties.icon = text;
    return this;
  }

  zone(zone: string): this {
    this.widget.widgetConfiguration.attributes['zone'] = zone;
    return this;
  }
}
export class MultiIconQuickLinkWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(multiIconQuickLinkWidgetConfig);
  }

  icons(icons: { left: string; right: string }): this {
    this.widget.widgetConfiguration.attributes['iconConfig'].leftIcon = icons.left;
    this.widget.widgetConfiguration.attributes['iconConfig'].rightIcon = icons.right;
    return this;
  }

  zone(zone: string): this {
    this.widget.widgetConfiguration.attributes['zone'] = zone;
    return this;
  }
  template(template: string): this {
    this.widget.widgetConfiguration.attributes['itemConfig'].itemTemplate = template;
    return this;
  }
}

export class NotificationsWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(notificationWidgetConfig);
  }

  notificationSetting(setting: NotificationSettingsWidgetLevel): this {
    this.widget.widgetConfiguration.attributes.widgetProperties['notificationSettings'] = setting;
    return this;
  }
}

export class CurrencyAccountsListingWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(currencyAccountsListingWidgetConfig);
  }
}

export class BulkPaymentAccountsListingWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(bulkPaymentAccountsListingWidgetConfig);
  }
}

export class AddCurrencyAccountWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(addCurrencyAccountWidgetConfig);
  }
  allowedCurrencies(currencies: AllowedCurrencyType[]) {
    this.widget.widgetConfiguration.attributes.widgetProperties.allowedCurrencies = currencies;
    return this;
  }
  setZone(zone: string): this {
    this.widget.widgetConfiguration.attributes['zone'] = zone;
    return this;
  }
}

export class LottieAnimationWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(lottieAnimationWidgetConfig);
  }
}

export class PaymentRefConfigBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(paymentRefConfig);
  }
}

export class CurrencyInputFieldWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(currencyInputFieldWidgetConfig);
  }
}

export class ExchangeCurrencyWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(exchangeCurrencyWidgetConfig);
    this.widget.widgetConfiguration.attributes.css_config = {
      ...this.widget.widgetConfiguration.attributes.css_config,
      borderWidth: 0,
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
    };
  }
  context(context: 'Buy' | 'Sell'): IWidgetBuilder {
    this.widget.widgetConfiguration.attributes.widgetProperties.context = context;
    return this;
  }
}

export class FormSubmissionButtonWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(
      getCTAButtonsWidgetConfig(WidgetNames.ACTION_BUTTON, WidgetTitles.MANDATORY_CTA_BUTTON),
    );
  }
}

export class SwitchNavigatorWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(switchNavigatorQuickLinkWidgetConfig);
  }

  linksData(linksData: LinksListType[]): this {
    this.widget.widgetConfiguration.attributes.linksList = linksData;
    return this;
  }
}

export class ImageWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(imageWidgetWidgetConfig);
  }
}
export class CurrencyExchangeTransactionHistoryBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(exchangetransactionHistoryWidgetConfig);
  }
}
export class EditBeneficiaryInternationalCurrencyCountryWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(
      getIntlCurrencyCountryWidgetConfigEditBeneficairy(
        JSON.parse(JSON.stringify(intlCurrencyCountryWidgetConfig)),
      ),
    );
  }
}

export class EditBeneficiaryIntlNewCurrencyCountryWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(
      getIntlNewCurrencyCountryWidgetConfigEditBeneficiary(
        JSON.parse(JSON.stringify(intlCurrencyCountryWidgetConfig)),
      ),
    );
  }
}

export class BackButtonWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(backButtonWidgetConfig);
  }

  icon(iconName: string): IWidgetBuilder {
    this.widget.widgetConfiguration.attributes.widgetProperties.icon = iconName;
    return this;
  }

  defaultBackButton(): IWidgetBuilder {
    return this.setWidgetProperties({
      icon: '',
      textContent: 'Back',
    }).cssConfig({
      color: 'var(--color-on-background)',
      textFont: 'var(--font-family)',
      fontSize: 14,
      display: 'flex',
      verticalAlignment: 'center',
      textAlignment: 'center',
      backGroundColor: 'var(--color-primary)',
      borderRadiusUnit: 'px',
      borderRadiusTopLeft: 6,
      borderRadiusTopRight: 6,
      borderRadiusBottomLeft: 6,
      borderRadiusBottomRight: 6,
    });
  }
}

export class FileUploadWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(fileUploadWidgetConfig);
  }
}

export class CompanyNameWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(verificationOrganisationCompanyNameWidget);
  }
}
export class EditAddressWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(editAddressWidget);
  }
}

export class DesktopBulkPaymentListingWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(desktopBulkPaymentListingWidgetConfig);
  }
}

export class DesktopBulkPaymentHistoryListingWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(desktopBulkPaymentHistoryListingWidgetConfig);
  }
}

export class AccountContextDropdownWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(accountsContextDropdownWidgetConfig);
  }
}

export class OnboardingNextBackWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(backNextButtonWidgetConfig);
  }
}

export class ConditionalWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(conditionalWidgetConfig);
  }
}

export class CalendarWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(calendarWidgetConfig);
  }
}

export class UploadFileWithPopupWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(uploadFileWithPopupWidgetConfig);
  }
}

export class CardsWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(cardsWidgetConfig);
  }
}

export class CardPINWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(cardPinWidgetConfig);
  }
}
export class CardSensitiveDetailsBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(cardSensitiveDetailsConfig);
  }
}
export class iFrameWidgetWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(iFrameWidgetWidgetConfig);
  }
}

export class DesktopPaymentRequestPendingListingWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(desktopPaymentRequestPendingListingWidgetConfig);
  }
}

export class TabWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(tabWidgetConfig);
  }
}

export class SectionWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(sectionWidgetConfig);
  }
}

export class TwoColumnWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(twoColumnWidgetConfig);
  }
}
export class SecondaryIdentifierWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(secondaryIdentifierWidgetConfig);
  }
}

export class SpacerWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(spacerWidgetConfig);
  }
  setHeight(config: { height: number; unit: string }): this {
    this.widget.widgetConfiguration.attributes.css_config.height = config.height;
    this.widget.widgetConfiguration.attributes.css_config.heightUnit = config.unit;
    return this;
  }
}
export class CardNameWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(cardNameWidgetConfig);
  }
}

export class BiometricsAuthenticationWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(biometricsAuthenticationWidgetConfig);
  }
}

export class AddToGooglePayWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(addToGooglePayWidgetConfig());
  }
}

export class AddToAppleWalletWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(addToAppleWalletWidgetConfig());
  }
}

export class PaymentRailSelectorWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(paymentRailSelectorWidgetConfig);
  }
}

export class EditBeneficiaryAddressWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(getEditBeneficiaryAddressWidget());
  }
}

export class ThemeSelectorWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(getThemeSelectorWidgetConfig());
  }
}

export class BeneficiaryTypeWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(beneficiaryTypeWidgetConfig);
  }
}

export class AccountRequestListWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(accountRequestListWidgetConfig);
  }
}

export class AccordionWidgetBuilder extends BaseWidgetBuilder {
  constructor() {
    super();
    this.widget = initWidgetBuilder(accordionWidgetConfig);
  }
}
